import { render, staticRenderFns } from "./base-drawer.vue?vue&type=template&id=3f5b97a7&scoped=true&"
import script from "./base-drawer.vue?vue&type=script&lang=js&"
export * from "./base-drawer.vue?vue&type=script&lang=js&"
import style0 from "./base-drawer.vue?vue&type=style&index=0&id=3f5b97a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b97a7",
  null
  
)

export default component.exports